<template>
  <footer class="footer">
    <div :class="['footerInner', isIs24 ? 'is24' : 'hg']">
      <div class="discriptionContainer">
        <HgIcon
          :icon="Icon.Premium"
          :color="isIs24 ? 'light' : 'secondary'"
          size="large"
          class="icon"
        />
        <div class="discription">
          <span class="heading">{{ t('footerBanner.title') }}</span>
          <span class="text">{{ t('footerBanner.text') }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { HgIcon, Icon } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const isIs24 = isPlatformIs24();
</script>

<style lang="scss" scoped>
@use '@/assets/variables' as *;
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  right: 0;
}

.footerInner {
  display: flex;
  justify-content: center;
  width: 100%;

  &.hg {
    background-color: $color-grey-40;
  }

  &.is24 {
    background-color: $color-grey-100;
    color: $color-white;
  }
}

.discriptionContainer {
  display: flex;
  flex-direction: row;
  gap: $space-50;
  padding: $space-100;

  @include grid-media-query(sm) {
    max-width: $funnel-container-max-width;
  }
}

.discription {
  display: flex;
  flex-direction: column;
  column-gap: $space-25;
}

.heading {
  @include body-2-semi-bold;
}

.text {
  @include body-2;
}

.icon {
  height: $space-150;
  width: $space-150;
}
</style>
